import type { Breadcrumb } from '@sentry/react';

import { safePathname } from './beforeSend';

/**
 * Drops the query string from a navigation breadcrumb's `from` and `to`.
 *
 * - Single-use credentials (invite, claim, password-reset tokens) arrive in the query string.
 * - Only `navigation` is touched: the one category filled from `location.href`.
 * - Not exported: `initSentry` wires it unconditionally so an app cannot drop this rule.
 */
export const beforeBreadcrumb = (crumb: Breadcrumb): Breadcrumb => {
  if (crumb.category !== 'navigation') return crumb;

  return {
    ...crumb,
    data: {
      ...crumb.data,
      from: safePathname(crumb.data?.from),
      to: safePathname(crumb.data?.to),
    },
  };
};
